import Helmet from 'react-helmet'
import React from 'react'

export const Course = (name, description, provider) => ({
  "@context": "http://schema.org",
  "@type": "Course",
  name,
  description,
  "provider": {
    "@type": "Organization",
    "name": `${provider}`
  }
});

export const ContactPoint = () => ({
  "@context": "http://schema.org",
  "@id": "https://www.univillage.co/#Organization",
  "@type": "Organization",
  "name": "Uni Village Education",
  "url": "https://www.univillage.co/",
  "logo": "https://www.univillage.co/univillage-logo-250x250.png",
  "contactPoint": [
    {
  		"@type": "ContactPoint",
  		"telephone": "+60-123129981",
  		"contactType": "customer support",
  		"areaServed": [ "MY" ]
  	}
  ],
  "sameAs": [
    "https://www.facebook.com/univillage.co/",
    "https://twitter.com/univillageedu",
    "https://www.youtube.com/channel/UCfNzjgBZzcQr5axNjdPanXQ",
    "https://www.instagram.com/univillageedu/"
  ]
});

export const Occupation = () => ({
  "@context": "http://schema.org",
  "@type": "Occupation",
});

export const Book = () => ({
  "@context": "http://schema.org",
  "@type": "Book",
});

export const Article = (authorName, headline, organization, url, description, images) => ({
  "@context": "http://schema.org",
  "@type": "Article",
  "author": {
    "@type": "Person",
    "name": `${authorName}`
  },
  headline,
  "publisher": {
    "@type": "Organization",
    "name": `${organization}`,
    "logo": {
      "@type": "ImageObject",
      "url": `${url}`
    }
  },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://google.com/article"
  },
  "datePublished": `${new Date()}`,
  "dateModified": `${new Date()}`,
  "image": images,
  description,
  url
});

const breadcrumbItem = ({name, id}, idx) => ({
    "@type": "ListItem",
    "position": idx,
    "item": {
      name,
      "@id": id
    }
});

export const Breadcrumb = (breadcrumbList) => ({
  "@context": "http://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbList.map(breadcrumbItem)
});

const StructureData = ({meta}) => {
  const script = [{
    'type': 'application/ld+json',
    'innerHTML': JSON.stringify(meta)
  }];
  return <Helmet script={script} />
};

export default StructureData;



// WEBPACK FOOTER //
// ./src/components/StructureData/index.js